import liff from "@line/liff";
import { getAssetUrl } from "@utils/getAssetUrl";

export const handleCollectListShareFriend = async (
	code: string,
	trackingId: string,
) => {
	try {
		const shareUrl = `${process.env.REACT_APP_LIFF_URL}/ec/collectList/from-liff-share/${code}?td=${trackingId}`;
		const result = await liff.shareTargetPicker([
			{
				type: "text",
				text: `我想和你分享我的最愛清單。​`,
			},
			{
				type: "flex",
				altText: `我想和你分享我的最愛清單。`,
				contents: {
					type: "bubble",
					size: "giga",
					hero: {
						type: "image",
						url: getAssetUrl(
							"/images/ec-campaign/flex-message/collect-list-content.png",
						),
						size: "full",
						aspectMode: "cover",
						aspectRatio: "357:290",
						action: { type: "uri", label: "立即尋找靈感", uri: shareUrl },
					},
				},
			},
			{
				type: "flex",
				altText: `我想和你分享我的最愛清單。`,
				contents: {
					type: "bubble",
					size: "giga",
					hero: {
						type: "image",
						url: getAssetUrl(
							"/images/ec-campaign/flex-message/collect-list-btn.png",
						),
						size: "full",
						aspectMode: "cover",
						aspectRatio: "357:41",
						action: { type: "uri", label: "打開作品", uri: shareUrl },
					},
				},
			},
		]);

		if (result) {
			console.log("分享成功");
		}
	} catch (error) {
		console.error("分享時發生錯誤:", error);
	}
};
